module.exports = __webpack_public_path__ + "static/collect-6-1fc91a87d9061cf99d3f19fca33bba8b.png";